import React from 'react';
import { useSelector } from 'react-redux';
import * as colors from '@constants/colors';
import { isAnyMapItemLoading } from '@selectors/map-selector';
import DotmapsLoader from '@shared/dotmaps-loader';

// Use this component instead of using DotmapsLoader directly,
// to avoid having to re-render the main Map component if
// the 'loader' property changes.
const Loader = () => {
  const loader = useSelector(isAnyMapItemLoading);

  return loader ? <DotmapsLoader color={colors.dotmapsGreen} /> : null;
};

export default Loader;
